import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import useMountTransition from '../../hooks/useMountTransition';
const Modal = (props) => {
    const [renderModal, visibleModal] = useMountTransition(props.show, 300);
    const [renderBackdrop, visibleBackDrop] = useMountTransition(props.show, 150);
    const titleId = React.useId();
    const dialog = React.useRef(null);
    const onClose = React.useRef(props.onClose);
    onClose.current = props.onClose;
    React.useEffect(() => {
        if (!renderModal || !dialog.current)
            return;
        const previousFocus = document.activeElement;
        const element = dialog.current;
        element.querySelector('button')?.focus();
        const onKeyDown = (event) => {
            if (event.key === 'Escape') {
                event.stopPropagation();
                onClose.current();
                return;
            }
            if (event.key !== 'Tab')
                return;
            const focusable = Array.from(element.querySelectorAll('button:not(:disabled),a[href],input:not(:disabled),select:not(:disabled),textarea:not(:disabled),summary,[tabindex="0"]'))
                .filter(x => x.getClientRects().length > 0);
            const first = focusable[0];
            const last = focusable[focusable.length - 1];
            if (event.shiftKey && document.activeElement === first) {
                event.preventDefault();
                last?.focus();
            }
            else if (!event.shiftKey && document.activeElement === last) {
                event.preventDefault();
                first?.focus();
            }
        };
        element.addEventListener('keydown', onKeyDown);
        return () => { element.removeEventListener('keydown', onKeyDown); previousFocus?.focus(); };
    }, [renderModal]);
    return (renderModal || renderBackdrop) && _jsxs(_Fragment, { children: [_jsx("div", { className: `modal fade${visibleModal ? ' show' : ''}`, tabIndex: -1, role: "dialog", "aria-modal": "true", "aria-labelledby": titleId, ref: dialog, style: { 'display': renderModal || visibleModal ? 'block' : 'none' }, children: _jsx("div", { className: `modal-dialog${props.size ? ` modal-${props.size}` : ''}${props.scrollable ? ' modal-dialog-scrollable' : ''}`, children: _jsxs("div", { className: "modal-content", children: [_jsxs("div", { className: "modal-header", children: [_jsx("h5", { id: titleId, className: "modal-title", children: props.title }), _jsx("button", { type: "button", className: "btn-close", "aria-label": "Close", onClick: props.onClose })] }), _jsx("div", { className: "modal-body", children: props.children }), _jsxs("div", { className: "modal-footer", children: [_jsx("button", { type: "button", className: "btn btn-secondary", onClick: props.onClose, children: "Close" }), props.onSubmit && _jsx("button", { type: "button", className: "btn btn-primary", onClick: props.onSubmit, children: "Submit" })] })] }) }) }), _jsx("div", { className: `modal-backdrop fade ${visibleBackDrop ? 'show' : ''}`, style: { 'display': renderBackdrop || visibleBackDrop ? '' : 'none' }, onClick: props.onClose })] });
};
export default Modal;
